import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Col, Row, Typography, Button, Card } from 'antd';
import { FileOutlined, UserOutlined } from '@ant-design/icons';
import ModalDemurContract from '../../components/modals/ModalDemurContract';
import ModalSignContract from '../../components/modals/ModalSignCanvas';
import ShowPdf from '../pdf/ShowPdf';
import { SIGN_CONTRACT, DEMUR_CONTRACT } from '../../state/lease_contract/types';
import { RESOURCE } from '../../config/constants/alerts';
import PropTypes from 'prop-types';

const { Title } = Typography;

const SignDocument = ({
  changeView,
  contract,
  sendSignContract,
  tokenParams,
  signerRole,
  contractIsSigned,
  sendDemurContract,
  contractIsDemur,
  error,
  contractPdf
}) => {

  const { params } = useParams();
  const [demurVisible, setDemurVisible] = useState(false);
  const [canvasVisible, setCanvasVisible] = useState(false);
  const [modalSpinning, setModalSpinning] = useState(false);

  useEffect(() => {
    if (contractIsSigned) {
      setModalSpinning(false);
      changeView(2);
    }
  }, [contractIsSigned]);

  useEffect(() => {
    if (contractIsDemur) {
      setModalSpinning(false);
      changeView(3);
    }
  }, [contractIsDemur]);

  useEffect(() => {
    setModalSpinning(false);
  }, [error]);

  const demurContract = (msg) => {
    setModalSpinning(true);
    sendDemurContract(tokenParams[0], { ...signerRole }, msg);
  };

  const signContract = (sign) => {
    setModalSpinning(true);
    sendSignContract(tokenParams[0], { ...signerRole }, sign, params);
  };

  return (
    <>
      <Row>
        <Col xs={24} md={20} lg={16} className="mx-auto">
          <Title level={2}>Validación de contrato de arriendo</Title>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col xs={24} md={24} lg={16} className="mx-auto">
          <Card>
            <Row className="mb-2">
              <Col>
                <Title level={4}>Firmantes</Title>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={8} >
                <Row>
                  <div className="circle-icon circle-purple circle-sign mb-4">
                    <UserOutlined style={{ fontSize: '20px' }} />
                  </div>
                  <div>
                    <Title level={5}>Arrendador</Title>
                    <p className="small">{contract.arrendador.nombre} {contract.arrendador.apellido} {contract.arrendador.segundoApellido}</p>
                  </div>
                </Row>
              </Col>
              <Col md={8} >
                <Row>
                  <div className="circle-icon circle-green circle-sign mb-4">
                    <UserOutlined style={{ fontSize: '20px' }} />
                  </div>
                  <div>
                    <Title level={5} >Arrendatario</Title>
                    <p className="small">{contract.arrendatario.nombre} {contract.arrendatario.apellido} {contract.arrendatario.segundoApellido}</p>
                  </div>
                </Row>
                {contract.arrendatarios && contract.arrendatarios[0] && (
                  contract.arrendatarios.map((lessor, key) => (
                    <Row key={key}>
                      <div className="circle-icon circle-green circle-sign mb-4">
                        <UserOutlined style={{ fontSize: '20px' }} />
                      </div>
                      <div>
                        <Title level={5} >Arrendatario</Title>
                        <p className="small">{lessor.nombre} {lessor.apellido}</p>
                      </div>
                    </Row>
                  ))
                )}
              </Col>
              {contract.codeudor &&
                <Col md={8} >
                  <Row>
                    <div className="circle-icon circle-blue circle-sign mb-4">
                      <UserOutlined style={{ fontSize: '20px' }} />
                    </div>
                    <div>
                      <Title level={5}>Codeudor</Title>
                      <p className="small">{contract.codeudor.nombre} {contract.codeudor.apellido} {contract.codeudor.segundoApellido}</p>
                    </div>
                  </Row>
                  {contract.codeudores && contract.codeudores[0] && (
                    contract.codeudores.map((codebtor, key) => (
                      <Row key={key}>
                        <div className="circle-icon circle-blue circle-sign mb-4">
                          <UserOutlined style={{ fontSize: '20px' }} />
                        </div>
                        <div>
                          <Title level={5} >Codeudor</Title>
                          <p className="small">{codebtor.nombre} {codebtor.apellido}</p>
                        </div>
                      </Row>
                    ))
                  )}
                </Col>
              }
            </Row>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={24} lg={16} className="mx-auto">
          <ShowPdf pdf={contractPdf} id={tokenParams[0]} />
        </Col>
      </Row>
      <div className="buttons-container shadow-lg justify-content-end">

        <Col xs={9} sm={7} md={6} lg={4} xl={3}>
          <Button className="mr-2 px-4" size="large" type="dashed" style={{ color: '#3366FF', borderColor: '#3366FF' }} onClick={() => setDemurVisible(true)}>
            <FileOutlined /> Objetar
          </Button>
        </Col>
        <Col xs={11} sm={10} md={7} lg={8} xl={7}>
          <Button className="px-4 agree-btn" size="large" onClick={() => setCanvasVisible(true)}>
            Validar
          </Button>
        </Col>

  
    
    
      </div>
      <ModalDemurContract
        visible={demurVisible}
        onCancel={() => setDemurVisible(false)}
        onCreate={demurContract}
        spinning={modalSpinning}
      />
      <ModalSignContract
        visible={canvasVisible}
        onCancel={() => setCanvasVisible(false)}
        onCreate={signContract}
        spinning={modalSpinning}
      />
    </>
  );
};

SignDocument.propTypes = {
  changeView: PropTypes.func.isRequired,
  contract: PropTypes.object.isRequired,
  sendSignContract: PropTypes.func.isRequired,
  tokenParams: PropTypes.array.isRequired,
  signerRole: PropTypes.object.isRequired,
  contractIsSigned: PropTypes.bool.isRequired,
  sendDemurContract: PropTypes.func.isRequired,
  contractIsDemur: PropTypes.bool.isRequired,
  error: PropTypes.object.isRequired,
  contractPdf: PropTypes.string.isRequired,
};

const data = (state) => ({
  contract: state.contract.contract,
  contractIsSigned: state.contract.contractIsSigned,
  contractIsDemur: state.contract.contractIsDemur,
  error: state.error,
  contractPdf: state.contract.contractPdf,
  signerRole: state.contract.signerRole
});

const action = (dispatch) => ({
  sendSignContract: (id, rol, signature, token) => dispatch({ type: SIGN_CONTRACT, payload: { id, rol, signature, token, resource: RESOURCE.SIGN_CONTRACT } }),
  sendDemurContract: (id, rol, msg) => dispatch({ type: DEMUR_CONTRACT, payload: { id, rol, msg, resource: RESOURCE.DEMUR_CONTRACT } }),
});

export default connect(data, action)(SignDocument);